import { ReactNode } from 'react';

import theme from '@/styles/theme';

import { ClickableIconStyle } from './style';

interface IClickableIconProps {
  children?: ReactNode;
  baseColor?: keyof typeof theme.colors;
  baseColorTransparency?: number;
  onClick?: () => void;
}

export default function ClickableIcon({
  children,
  baseColor,
  baseColorTransparency = 0,
  onClick,
}: IClickableIconProps) {
  return (
    <ClickableIconStyle
      $baseColor={baseColor}
      $baseColorTransparency={baseColorTransparency}
      onClick={onClick}
    >
      {children}
    </ClickableIconStyle>
  );
}
